export default "__VITE_ASSET__QoS3uPCN__"